var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecivedPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6928 13.498H7.53223V35.0347H44.6928V13.498Z",
    fill: "white",
    stroke: "#FE6338",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.9325 15.9951V32.5368H28.7412C29.8853 32.0728 30.8964 31.335 31.6846 30.3891H36.8482C36.8482 29.6182 37.1562 28.879 37.7045 28.3339C38.2528 27.7889 38.9964 27.4826 39.7719 27.4826V21.0493C38.9964 21.0493 38.2528 20.7431 37.7045 20.198C37.1562 19.6529 36.8482 18.9138 36.8482 18.143H31.6599C30.8786 17.2002 29.8763 16.4626 28.7412 15.9951H41.9325Z",
    fill: "#FE6338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.358 16.9854C23.0973 16.9854 20.4512 20.2661 20.4512 24.3152C20.4512 28.3644 23.0973 31.6599 26.358 31.6599C29.6186 31.6599 32.2648 28.3792 32.2648 24.33C32.2648 20.2808 29.6186 16.9854 26.358 16.9854ZM29.7326 26.4828C29.3474 26.3487 28.9457 26.2675 28.5384 26.2414C28.1935 26.2125 27.8571 26.1188 27.5473 25.9655C28.0518 25.7013 28.4728 25.303 28.7632 24.8152C29.0537 24.3273 29.2023 23.7688 29.1925 23.2019C29.2207 22.8145 29.1684 22.4253 29.0385 22.0588C28.9087 21.6924 28.7044 21.3563 28.4381 21.0719C28.1719 20.7874 27.8497 20.5605 27.4914 20.4054C27.133 20.2502 26.7464 20.1701 26.3554 20.1701C25.9646 20.1701 25.578 20.2502 25.2197 20.4054C24.8613 20.5605 24.5391 20.7874 24.2728 21.0719C24.0066 21.3563 23.8023 21.6924 23.6725 22.0588C23.5427 22.4253 23.4903 22.8145 23.5185 23.2019C23.5098 23.7692 23.6594 24.3277 23.9507 24.8156C24.2419 25.3034 24.6636 25.7014 25.1687 25.9655C24.8589 26.1188 24.5226 26.2125 24.1776 26.2414C23.7775 26.2656 23.3824 26.3436 23.0032 26.4729C22.6969 26.6049 22.4477 26.8405 22.2994 27.1379C21.9412 26.2397 21.7596 25.2815 21.7644 24.3152C21.7644 20.9853 23.8307 18.276 26.3729 18.276C28.915 18.276 30.9813 20.9853 30.9813 24.3152C30.9862 25.2815 30.8044 26.2397 30.4462 27.1379C30.2938 26.8425 30.0409 26.6103 29.7326 26.4828Z",
    fill: "#FE6338"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.0556 30.3891H15.3619C15.3619 29.6182 15.0539 28.879 14.5056 28.3339C13.9572 27.7889 13.2136 27.4826 12.4382 27.4826V21.0493C13.2136 21.0493 13.9572 20.7431 14.5056 20.198C15.0539 19.6529 15.3619 18.9138 15.3619 18.143H21.0556C21.843 17.1959 22.8544 16.4579 23.9992 15.9951H10.2876V32.5368H23.9992C22.8544 32.074 21.843 31.3361 21.0556 30.3891Z",
    fill: "#FE6338"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8493 33.9411H24.2417L31.66 30.3057H42.8493V33.9411Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8496 15.3057V33.2166H26.3184L42.8496 15.3057Z",
    fill: "#FE6338"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4728 33.4824H28.7314V48.3887H52.4728V33.4824Z",
    fill: "white",
    stroke: "#FE6338",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8859 35.8867H31.313V38.3694H49.8859V35.8867Z",
    fill: "#FE6338"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0458 43.877C36.0458 44.2689 35.8891 44.6448 35.6104 44.922C35.3315 45.1991 34.9534 45.3549 34.5592 45.3549L33.3897 45.3006C32.9908 45.3006 32.6083 45.1431 32.3262 44.8628C32.0442 44.5823 31.8857 44.2021 31.8857 43.8056C31.8857 43.4091 32.0442 43.0289 32.3262 42.7484C32.6083 42.4681 32.9908 42.3105 33.3897 42.3105",
    stroke: "#FE6338",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4844 43.8177C34.4844 43.4258 34.6411 43.0499 34.9198 42.7727C35.1986 42.4956 35.5766 42.3398 35.971 42.3398L37.1405 42.3989C37.5386 42.3989 37.9206 42.5562 38.2022 42.8361C38.4838 43.116 38.642 43.4957 38.642 43.8915C38.642 44.2875 38.4838 44.6671 38.2022 44.947C37.9206 45.2269 37.5386 45.3842 37.1405 45.3842",
    stroke: "#FE6338",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5997 35.2812V46.6504H39.1626L50.5997 35.2812Z",
    fill: "#FE6338"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecivedPayment);
export default __webpack_public_path__ + "static/media/recived-payment.1dac5c19bd52508a9db9d6bbaa9e68e2.svg";
export { ForwardRef as ReactComponent };